import { MINUTES_IN_MS } from '../constants.js';

export const getClosestHourMinutes = (sessionStartTime: Date) => {
  const now = Date.now();
  const start = sessionStartTime.getTime();
  const minutes = Math.round((now - start) / (1000 * 60 * 60)) * 60; // Round to nearest hour in minutes
  return minutes;
};

export const getNextHourMinutes = (sessionStartTime: Date) => {
  const now = Date.now();
  const start = sessionStartTime.getTime();
  const minutes = Math.ceil((now - start) / (1000 * 60 * 60)) * 60; // Round up to next hour in minutes
  return Math.max(minutes, 60); // Ensure at least 60 minutes for the next hour
};

export const getTimeToNextHourMinutes = (sessionTimeMs: number, sessionStartTime: Date) => {
  const nextHourInMinutes = getNextHourMinutes(sessionStartTime);
  const loggedInMinutes = Math.floor(sessionTimeMs / MINUTES_IN_MS);
  return nextHourInMinutes - loggedInMinutes;
};
